export enum ErrorCodeCategory {
  MinorNote = 'MinorNote',
  Note = 'Note',
  Warning = 'Warning',
  Alarm = 'Alarm',
}
